<template>
  <div>
    <div class="home-nav header-message">
      <a-row>
        <a-col :span="8">
          <a-row>
            <a-col :span="3">
              <img src="@assets/home/userHead.png" alt class="user-head" />
            </a-col>
            <a-col :span="21">
              <div style="text-align: left">
                <p>HI，{{ homeInfo.realName }}</p>
                <p>
                  上次登录地址：
                  <span>{{ homeInfo.loginIp }}（IP）</span>
                </p>
                <p>
                  上次登录时间：
                  <span>{{ homeInfo.loginTime }}</span>
                </p>
              </div>
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="16">
          <div style="text-align: right">
            <div class="num-box">
              <div>
                <span class="num">{{ homeInfo.jrXzzjNum }}</span>
              </div>
              <div>
                <span class="num-desc">今日新增用户数量</span>
              </div>
            </div>

            <div class="num-box" style="background-color: rgb(28, 226, 173)">
              <div>
                <span class="num">{{ homeInfo.byXzzjNum }}</span>
              </div>
              <div>
                <span class="num-desc">本月新增用户数量</span>
              </div>
            </div>

            <div class="num-box" style="background-color: rgb(255, 192, 0)">
              <div>
                <span class="num">1235</span>
              </div>
              <div>
                <span class="num-desc">平台总用户数量</span>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>

    <div>
      <a-row>
        <a-col :span="16">
          <!--快捷导航-->
          <div class="home-nav">
            <div class="home-top">
              <img src="@assets/home/kjdh.svg" alt class="box-img" />
              <span>快捷导航</span>
            </div>
            <a-row style="height: 665px">
              <a-col :span="12">
                <div class="home-box">
                  <img src="@assets/home/zxtgl.png" alt class="box-img" />
                  <span class="box-title" @click="goOtherPage('isystem/info')">子系统管理</span>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="home-box">
                  <img src="@assets/home/yhgl.png" alt class="box-img" />
                  <span class="box-title" @click="goOtherPage('isystem/user')">用户管理</span>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="home-box">
                  <img src="@assets/home/jsgl.png" alt class="box-img" />
                  <span class="box-title" @click="goOtherPage('isystem/roleUserList')">角色管理</span>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="home-box">
                  <img src="@assets/home/bmgl.png" alt class="box-img" />
                  <span class="box-title" @click="goOtherPage('isystem/depart')">部门管理</span>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="home-box">
                  <img src="@assets/home/zxtgl.png" alt class="box-img" />
                  <span class="box-title" @click="goOtherPage('isystem/departUserList')">我的部门</span>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="home-box">
                  <img src="@assets/home/yhgl.png" alt class="box-img" />
                  <span class="box-title" @click="goOtherPage('isystem/position')">职务管理</span>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="home-box">
                  <img src="@assets/home/jsgl.png" alt class="box-img" />
                  <span class="box-title" @click="goOtherPage('isystem/dict')">数据字典</span>
                </div>
              </a-col>
              <a-col :span="12">
                <div class="home-box">
                  <img src="@assets/home/bmgl.png" alt class="box-img" />
                  <span class="box-title" @click="goOtherPage('isys/category')">分类字典</span>
                </div>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :span="8">
          <!--通知公告-->
          <HomeNotice style="height: 725px" />
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import { getAction, downFile } from '@/api/manage.js'
import pick from 'lodash.pick'
import Vue from 'vue'
import HomeNotice from './modules/HomeNotice'

export default {
  name: 'Analysis',
  components: {
    HomeNotice
  },
  data() {
    return {
      description: '这是首页',
      homeInfo: {
        homeType: ''
      },
      tradeSysUrl: window._CONFIG['tradeSysUrl']
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      getAction(this.tradeSysUrl + '/api/home/getHomeInfo', { appType: 'ZJCQ' }).then((res) => {
        this.homeInfo = res.result
        console.log('this.homeInfo======>', res.result.homeType)
      })
    },
    goOtherPage(pagePath) {
      let { href } = this.$router.resolve({
        path: '/' + pagePath
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style lang="less">
.home-nav {
  background: #fff;
  border-radius: 4px;
  margin-top: 5px;
  margin-right: 5px;

  .home-top {
    height: 60px;
    border-bottom: 1px solid #ddd;
    font-size: 20px;
    padding: 16px 30px 0px 30px;
    vertical-align: middle;
  }

  .box-img {
    height: 40px !important;
    width: 40px !important;
    margin-top: -10px;
    margin-right: 15px;
  }

  .box-title {
    font-size: 16px;
  }

  .box-title:hover {
    cursor: pointer;
  }

  .home-box {
    height: 70px;
    border: 1px solid #ddd;
    font-size: 20px;
    padding: 16px 30px 0px 30px;
    vertical-align: middle;
    margin: 10px;
  }
}

.header-message {
  padding: 10px;

  .box {
    border-right: 1px solid #ddd;
  }

  .user-head {
    width: 50px;
  }

  .num-box {
    display: inline-block;
    margin-right: 30px;
    text-align: center;
    width: 150px;
    height: 86px;
    background-color: rgb(43, 201, 253);
    border-radius: 4px;

    .num {
      font-size: 30px;
      color: white;
      text-align: center;
    }

    .num-desc {
      color: white;
      text-align: center;
    }
  }
}
</style>
